import React from 'react';
import advocateProfilePic from '../../../assets/images/advocates-details/SivaPrasadRdy.jpg';

const AdvocateSivaPrasadRSDetails = () => {
  return (
    <section className='team-details'>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-lg-5'>
            <div className='team-details__content'>
              <h2 className='team-details__title'>Read my story</h2>
              <p className='team-details__text'>
                Mr. Shiva Prasad has completed his LL.B. from Padala Rama Reddi Law College, Hyderabad. 
                Currently pursuing his LL.M from Dr. BR Ambedkar Law College. 
                He is enrolled as an Advocate in the year 2024 and currently practicing at 
                Honarable High Court for the State of Telangana, Civil and Criminal Courts across Hyderabad.
              </p>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img
                  src={advocateProfilePic}
                  alt='Siva Prasad Reddy S'
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  Mr. Shiva Prasad Reddy Singapuram BB.A, MA (Psy), LL.B (LL.M)
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvocateSivaPrasadRSDetails;

